import { useEffect, useState } from 'react'
import { useAccount } from 'wagmi'

/// The raw EIP-1193 provider behind whichever wallet is currently connected via wagmi/RainbowKit
/// (the nav menu's own connect button) - lets an embedded widget (e.g. the CoW Swap widget on the
/// Buy page) reuse that same connection instead of running its own independent wallet-connect
/// flow. connector.getProvider() is async and wagmi doesn't expose a synchronous accessor, so this
/// re-resolves it whenever the active connector changes (new wallet connected/switched) and clears
/// it back to undefined on disconnect.
export function useEip1193Provider() {
  const { connector, isConnected } = useAccount()
  const [provider, setProvider] = useState(undefined)

  useEffect(() => {
    if (!isConnected || !connector) {
      setProvider(undefined)
      return
    }
    let cancelled = false
    connector.getProvider().then((p) => {
      if (!cancelled) setProvider(p)
    })
    return () => { cancelled = true }
  }, [connector, isConnected])

  return provider
}
